(() => {
  const boot = () => {
    document.querySelectorAll('[data-bf-plan-picker]').forEach((root) => {
      if (root.__bfInited) return;
      root.__bfInited = true;

      const LOCALE = 'en-EN';
      const pad2 = (n) => String(n).padStart(2, '0');
      const toISO = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      const toHumanShort = (d) => d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long' });
      const toHumanFull = (d) => d.toLocaleDateString(LOCALE, { year: 'numeric', month: 'long', day: 'numeric' });

      const addDays = (d, days) => {
        const x = new Date(d);
        x.setDate(x.getDate() + days);
        x.setHours(0, 0, 0, 0);
        return x;
      };

      const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
      const norm = (s) => (s ?? '').toString().trim().toLowerCase();
      const formatDaysValue = (n) => (n === 1 ? '1 day' : `${n} days`);

      const diffDaysInclusive = (a, b) => {
        const ms = 24 * 60 * 60 * 1000;
        const da = new Date(a); da.setHours(0, 0, 0, 0);
        const db = new Date(b); db.setHours(0, 0, 0, 0);
        return Math.round((db - da) / ms) + 1;
      };

      const inRange = (d, start, end) => {
        if (!start || !end) return false;
        const x = d.getTime();
        return x >= start.getTime() && x <= end.getTime();
      };

      // Scope del producto
      const scope = root.closest('product-info') || root.closest('.product') || document;

      // -----------------------------
      // RESOLVERS (Trade re-render FIX)
      // -----------------------------
      let form = null;
      let formId = null;
      let daysGroup = null;
      let planGroup = null;

      const getForm = () => {
        const addBtn = scope.querySelector('button[name="add"][form]');
        if (addBtn) {
          const fid = addBtn.getAttribute('form');
          const f = document.getElementById(fid);
          if (f) return f;
        }
        return (
          scope.querySelector('form[action*="/cart/add"][id^="product-form-"]') ||
          scope.querySelector('form[action*="/cart/add"]')
        );
      };

      const belongsToThisFormFactory = () => {
        return (el) => {
          if (!el) return false;
          const f = el.getAttribute('form');
          if (f && formId) return f === formId;
          return formId ? !!el.closest(`#${CSS.escape(formId)}`) : !!el.closest('form');
        };
      };

      const findOptionGroupFactory = (belongsToThisForm) => {
        return (optionName) => {
          const fieldsets = scope.querySelectorAll('fieldset');
          for (const fs of fieldsets) {
            const legend = fs.querySelector('legend');
            if (!legend) continue;
            if (!norm(legend.textContent).includes(norm(optionName))) continue;

            const radios = Array.from(fs.querySelectorAll('input[type="radio"]')).filter(belongsToThisForm);
            if (radios.length) return { type: 'radios', el: fs, radios };
          }

          const candidates = Array.from(
            scope.querySelectorAll(`select[name="options[${CSS.escape(optionName)}]"]`)
          );
          const sel = candidates.find(belongsToThisForm);
          if (sel) return { type: 'select', el: sel, select: sel };

          return null;
        };
      };

      const refreshBindings = () => {
        form = getForm();
        if (!form) return false;

        formId = form.getAttribute('id');

        const belongsToThisForm = belongsToThisFormFactory();
        const findOptionGroup = findOptionGroupFactory(belongsToThisForm);

        daysGroup = findOptionGroup('Days');
        planGroup = findOptionGroup('Plan type');

        return !!(daysGroup && planGroup);
      };

      if (!refreshBindings()) {
        console.warn('[BF] No encuentro el form o Days/Plan type.');
        return;
      }

      const getSelectedValue = (group) => {
        if (!group) return null;
        if (group.type === 'radios') {
          const checked = group.radios.find((r) => r.checked);
          return checked ? checked.value : null;
        }
        return group.select.value || null;
      };

      const selectOptionValue = (group, value) => {
        if (!group || !value) return;

        if (group.type === 'radios') {
          const radio = group.radios.find((r) => norm(r.value) === norm(value));
          if (radio) radio.click(); // click REAL
        } else {
          group.select.value = value;
          group.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      const getValues = (group) => {
        if (!group) return [];
        if (group.type === 'radios') {
          const vals = group.radios.map((r) => r.value);
          return vals.filter((v, i) => vals.indexOf(v) === i);
        }
        return Array.from(group.select.options).map((o) => o.value).filter(Boolean);
      };

      // Variants JSON
      const getProductJSON = () => {
        const jsonEl =
          scope.querySelector('variant-radios script[type="application/json"]') ||
          scope.querySelector('variant-selects script[type="application/json"]') ||
          scope.querySelector('product-info script[type="application/json"]');

        if (!jsonEl) return null;
        try {
          return JSON.parse(jsonEl.textContent);
        } catch (e) {
          console.warn('[BF] No pude parsear product JSON', e);
          return null;
        }
      };

      const productData = getProductJSON();
      const variants = Array.isArray(productData) ? productData : (productData?.variants || []);
      const optionNames = Array.isArray(productData?.options) ? productData.options : [];

      // ¿Days es option1 o option2?
      let daysFirst = true;
      if (optionNames.length >= 2) {
        const o1 = norm(optionNames[0]);
        const o2 = norm(optionNames[1]);
        if (o1.includes('plan') && o2.includes('day')) daysFirst = false;
        if (o1.includes('day') && o2.includes('plan')) daysFirst = true;
      }

      const getIdInput = () => form?.querySelector('input[name="id"]');

      const setVariantId = (variantId) => {
        const idInput = getIdInput();
        if (!idInput) return;
        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      // Properties (carrito)
      const getPropInput = (name) =>
        form?.querySelector(`input[name="properties[${CSS.escape(name)}]"]`) ||
        form?.querySelector(`textarea[name="properties[${CSS.escape(name)}]"]`) ||
        form?.querySelector(`select[name="properties[${CSS.escape(name)}]"]`);

      const setProp = (name, val) => {
        const el = getPropInput(name);
        if (!el) return;
        el.value = String(val ?? '');
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const findVariantByOptions = (daysVal, planVal) => {
        if (!variants.length) return null;

        return variants.find((v) => {
          const o1 = (v.option1 ?? (Array.isArray(v.options) ? v.options[0] : null));
          const o2 = (v.option2 ?? (Array.isArray(v.options) ? v.options[1] : null));
          if (!o1 || !o2) return false;

          if (daysFirst) {
            return norm(o1) === norm(daysVal) && norm(o2) === norm(planVal);
          }
          return norm(o1) === norm(planVal) && norm(o2) === norm(daysVal);
        }) || null;
      };

      const formatMoney = (cents) => {
        try {
          if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, Shopify.money_format);
        } catch (e) {}
        return (cents / 100).toFixed(2) + ' €';
      };

      // Actualizar precio visible
      const updatePriceUI = (variant) => {
        if (!variant) return;

        const price = variant.price;
        const formatted = formatMoney(price);

        const main = scope.querySelector('.price-item.price-item--regular');
        if (main) {
          const hadEUR = norm(main.textContent).includes('eur');
          main.textContent = hadEUR ? `${formatted} EUR` : formatted;
        }

        scope.querySelectorAll('.price .price-item--regular, .price .price-item--sale')
          .forEach((el) => {
            const hadEUR = norm(el.textContent).includes('eur');
            el.textContent = hadEUR ? `${formatted} EUR` : formatted;
          });
      };

      const syncVariantAndPrice = () => {
        if (!refreshBindings()) return;

        const daysVal = getSelectedValue(daysGroup);
        const planVal = getSelectedValue(planGroup);
        if (!daysVal || !planVal) return;

        const v = findVariantByOptions(daysVal, planVal);
        if (!v) {
          console.warn('[BF] No encontré variante para', { daysVal, planVal, daysFirst });
          return;
        }

        setVariantId(v.id);
        updatePriceUI(v);

        try {
          const idInput = getIdInput();
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.optionValueSelectionChange) {
            const selectedOptionValues = daysFirst ? [daysVal, planVal] : [planVal, daysVal];
            window.publish(window.PUB_SUB_EVENTS.optionValueSelectionChange, {
              event: new Event('change', { bubbles: true }),
              target: idInput,
              selectedOptionValues,
            });
          }
        } catch (e) {}
      };

      // -----------------------------
      // UI refs BF
      // -----------------------------
      const btnOpen = root.querySelector('[data-bf-open-calendar]');
      const modal = root.querySelector('[data-bf-modal]');
      const btnCloseEls = root.querySelectorAll('[data-bf-close]');
      const btnApply = root.querySelector('[data-bf-apply]');
      const dateText = root.querySelector('[data-bf-date-text]');
      const startDateInput = root.querySelector('[data-bf-start-date]');
      const endDateInput = root.querySelector('[data-bf-end-date]');
      const daysInput = root.querySelector('[data-bf-days]');
      const endText = root.querySelector('[data-bf-end-text]');
      const pillsWrap = root.querySelector('[data-bf-plan-pills]');
      const calHost = root.querySelector('[data-bf-inline]');
      const btnMinus = root.querySelector('[data-bf-days-minus]');
      const btnPlus = root.querySelector('[data-bf-days-plus]');

      if (!btnOpen || !modal || !btnApply || !pillsWrap || !calHost || !daysInput) {
        console.warn('[BF] Faltan elementos del HTML BF en la página.');
        return;
      }

      // ✅ Guardar “casa” del modal y funciones mover/restaurar (FIX CENTRADO REAL)
      let modalHomeParent = modal.parentNode;
      let modalHomeNext = modal.nextSibling;

      const moveModalToBody = () => {
        if (!modal) return;
        if (modal.parentNode === document.body) return;
        modalHomeParent = modal.parentNode;
        modalHomeNext = modal.nextSibling;
        document.body.appendChild(modal);
      };

      const restoreModalHome = () => {
        if (!modal || !modalHomeParent) return;
        if (modal.parentNode !== document.body) return;

        if (modalHomeNext && modalHomeNext.parentNode === modalHomeParent) {
          modalHomeParent.insertBefore(modal, modalHomeNext);
        } else {
          modalHomeParent.appendChild(modal);
        }
      };

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const selectedDaysValue = getSelectedValue(daysGroup);
      const initialDays = selectedDaysValue ? parseInt(selectedDaysValue, 10) : 1;
      const initialDaysClamped = clamp(initialDays || 1, 1, 90);

      let selectedStart = new Date(today);
      let selectedDays = initialDaysClamped;

      let stagedStart = new Date(selectedStart);
      let stagedEnd = addDays(stagedStart, selectedDays - 1);
      let picking = 'start';

      let viewMonth = stagedStart.getMonth();
      let viewYear = stagedStart.getFullYear();

      const renderPlanPills = () => {
        if (!refreshBindings()) return;
        const planValues = getValues(planGroup);
        const current = getSelectedValue(planGroup);

        pillsWrap.innerHTML = planValues
          .map((v) => {
            const active = norm(v) === norm(current) ? ' bf-pill--active' : '';
            return `<button type="button" class="bf-pill${active}" data-bf-plan="${encodeURIComponent(v)}">${v}</button>`;
          })
          .join('');
      };

      const syncUIPropsAndVariant = () => {
        if (!refreshBindings()) return;

        const n = clamp(parseInt(daysInput.value || String(selectedDays), 10) || 1, 1, 90);
        selectedDays = n;
        daysInput.value = String(n);

        const end = addDays(selectedStart, n - 1);

        if (startDateInput) startDateInput.value = toISO(selectedStart);
        if (endDateInput) endDateInput.value = toISO(end);

        if (dateText) dateText.textContent = toHumanFull(selectedStart);
        if (endText) endText.textContent = `From ${toHumanShort(selectedStart)} to ${toHumanShort(end)} (${n} days)`;

        selectOptionValue(daysGroup, formatDaysValue(n));

        setProp('Days', formatDaysValue(n));
        setProp('Start date', toISO(selectedStart));
        setProp('End date', toISO(end));

        syncVariantAndPrice();
        renderPlanPills();
      };

      pillsWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-bf-plan]');
        if (!btn) return;

        if (!refreshBindings()) return;

        const v = decodeURIComponent(btn.getAttribute('data-bf-plan'));
        selectOptionValue(planGroup, v);
        setProp('Plan type', v);

        syncVariantAndPrice();
        renderPlanPills();
      });

      btnMinus?.addEventListener('click', () => {
        daysInput.value = String(clamp((parseInt(daysInput.value || '1', 10) || 1) - 1, 1, 90));
        syncUIPropsAndVariant();
      });

      btnPlus?.addEventListener('click', () => {
        daysInput.value = String(clamp((parseInt(daysInput.value || '1', 10) || 1) + 1, 1, 90));
        syncUIPropsAndVariant();
      });

      daysInput.addEventListener('change', syncUIPropsAndVariant);

      // Modal open/close
      const openModal = () => {
        // ✅ mover el modal al BODY para evitar padres con transform (FIX)
        moveModalToBody();

        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('is-open');

        // ✅ asegurar overlay pantalla (sin cambiar tamaños)
        modal.style.position = 'fixed';
        modal.style.inset = '0';
        modal.style.zIndex = '2147483646';

        // ✅ centrar panel real (sin tocar width/height)
        const panel =
          modal.querySelector('.bf-cal-panel') ||
          modal.querySelector('.bf-modal__panel');

        if (panel) {
          panel.style.position = 'fixed';
          panel.style.left = '50%';
          panel.style.top = '50%';
          panel.style.transform = 'translate(-50%, -50%)';
          panel.style.margin = '0';
          panel.style.zIndex = '2147483647';
        }

        stagedStart = new Date(selectedStart);
        stagedEnd = addDays(stagedStart, selectedDays - 1);
        picking = 'start';

        viewMonth = stagedStart.getMonth();
        viewYear = stagedStart.getFullYear();

        renderCalendar();
      };

      const closeModal = () => {
        modal.setAttribute('aria-hidden', 'true');
        modal.classList.remove('is-open');

        // ✅ devolver el modal a su sitio original
        restoreModalHome();
      };

      btnOpen.addEventListener('click', openModal);
      btnCloseEls.forEach((el) => el.addEventListener('click', closeModal));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });

      const isPast = (d) => d.getTime() < today.getTime();

      const setRangeFromClicks = (start, end) => {
        let a = start, b = end;
        if (b.getTime() < a.getTime()) { const tmp = a; a = b; b = tmp; }

        let days = diffDaysInclusive(a, b);
        days = clamp(days, 1, 90);

        const realEnd = addDays(a, days - 1);

        stagedStart = new Date(a);
        stagedEnd = new Date(realEnd);
        selectedDays = days;
      };

      const renderCalendar = () => {
        const monthLabel = new Date(viewYear, viewMonth, 1).toLocaleDateString(LOCALE, {
          month: 'long',
          year: 'numeric',
        });

        const first = new Date(viewYear, viewMonth, 1);
        const startDow = (first.getDay() + 6) % 7; // Monday=0
        const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

        let cells = '';
        for (let i = 0; i < startDow; i++) {
          cells += `<button type="button" class="bf-cal-cell bf-cal-cell--empty" disabled></button>`;
        }

        for (let day = 1; day <= daysInMonth; day++) {
          const d = new Date(viewYear, viewMonth, day);
          d.setHours(0, 0, 0, 0);

          const disabled = isPast(d);
          const isStart = stagedStart && toISO(d) === toISO(stagedStart);
          const isEnd = stagedEnd && toISO(d) === toISO(stagedEnd);
          const isBetween = inRange(d, stagedStart, stagedEnd);

          const classes = [
            'bf-cal-cell',
            disabled ? 'is-disabled' : '',
            isBetween ? 'is-range' : '',
            isStart ? 'is-range-start' : '',
            isEnd ? 'is-range-end' : '',
          ].filter(Boolean).join(' ');

          cells += `<button type="button" class="${classes}" data-cal-day="${day}" ${disabled ? 'disabled' : ''}>${day}</button>`;
        }

        const summaryText = (stagedStart && stagedEnd)
          ? `From ${toHumanShort(stagedStart)} to ${toHumanShort(stagedEnd)} (${diffDaysInclusive(stagedStart, stagedEnd)} days)`
          : `Select an end date`;

        calHost.innerHTML = `
          <div class="bf-hf-note">
            <span class="bf-hf-note__icon">💡</span>
            <span>Your plan starts when you arrive and activate your eSIM.</span>
          </div>

          <div class="bf-cal-top">
            <button type="button" class="bf-step" data-cal-prev aria-label="Mes anterior">‹</button>
            <div class="bf-cal-month">${monthLabel}</div>
            <button type="button" class="bf-step" data-cal-next aria-label="Mes siguiente">›</button>
          </div>

          <div class="bf-cal-dow">
            <span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span>
          </div>

          <div class="bf-cal-grid">${cells}</div>

          <div class="bf-hf-summary">
            <div class="bf-hf-summary__left">
              <div class="bf-hf-summary__title">Your eSIM will be active:</div>
              <div class="bf-hf-summary__range">${summaryText}</div>
            </div>
          </div>
        `;

        calHost.querySelector('[data-cal-prev]').addEventListener('click', () => {
          viewMonth -= 1;
          if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
          renderCalendar();
        });

        calHost.querySelector('[data-cal-next]').addEventListener('click', () => {
          viewMonth += 1;
          if (viewMonth > 11) { viewMonth = 0; viewYear += 1; }
          renderCalendar();
        });

        calHost.querySelectorAll('[data-cal-day]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const day = parseInt(btn.getAttribute('data-cal-day'), 10);
            const clicked = new Date(viewYear, viewMonth, day);
            clicked.setHours(0, 0, 0, 0);

            if (isPast(clicked)) return;

            if (picking === 'start') {
              stagedStart = clicked;
              stagedEnd = null;
              picking = 'end';
            } else {
              setRangeFromClicks(stagedStart, clicked);
              picking = 'start';
            }
            renderCalendar();
          });
        });
      };

      btnApply.addEventListener('click', () => {
        if (!stagedEnd && stagedStart) {
          const n = clamp(parseInt(daysInput.value || String(selectedDays), 10) || 1, 1, 90);
          stagedEnd = addDays(stagedStart, n - 1);
          selectedDays = n;
        }

        selectedStart = new Date(stagedStart);
        selectedStart.setHours(0, 0, 0, 0);

        const finalDays = stagedEnd ? clamp(diffDaysInclusive(selectedStart, stagedEnd), 1, 90) : selectedDays;
        daysInput.value = String(finalDays);
        selectedDays = finalDays;

        syncUIPropsAndVariant();
        closeModal();
      });

      // INIT
      daysInput.value = String(initialDaysClamped);
      renderPlanPills();

      if (!refreshBindings()) return;
      const initPlan = getSelectedValue(planGroup);
      setProp('Plan type', initPlan || '');
      syncUIPropsAndVariant();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();